// TODO do wyjasnienia wartosci
export enum AnnouncementRecipientType {
  /*BENEFICIARIES = 'BENEFICIARIES',
  ORGANIZATIONS = 'ORGANIZATIONS',
  ALL_USERS = 'ALL_USERS',*/
  WSZYSCY = 'WSZYSCY',
  INDYWIDUALNY = 'INDYWIDUALNY',
  WNIOSEK = 'WNIOSEK',
}

export const ANNOUNCEMENT_RECIPIENT_TYPE_LABELS: Record<
  AnnouncementRecipientType,
  string
> = {
  /*[AnnouncementRecipientType.BENEFICIARIES]: 'Świadczeniobiorcy',
  [AnnouncementRecipientType.ORGANIZATIONS]: 'Organizacje',
  [AnnouncementRecipientType.ALL_USERS]: 'Wszyscy użytkownicy',*/
  [AnnouncementRecipientType.WSZYSCY]: 'Wszyscy',
  [AnnouncementRecipientType.INDYWIDUALNY]: 'Indywidualny',
  [AnnouncementRecipientType.WNIOSEK]: 'Wniosek',
};
